import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageAdd01 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6671_128240)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3334 5.75521C18.7476 5.75521 19.0834 5.41942 19.0834 5.00521C19.0834 4.59099 18.7476 4.25521 18.3334 4.25521V5.00521V5.75521ZM11.6667 4.25521C11.2525 4.25521 10.9167 4.59099 10.9167 5.00521C10.9167 5.41942 11.2525 5.75521 11.6667 5.75521V5.00521V4.25521ZM15.7501 1.67188C15.7501 1.25766 15.4143 0.921875 15.0001 0.921875C14.5859 0.921875 14.2501 1.25766 14.2501 1.67188H15.0001H15.7501ZM14.2501 8.33854C14.2501 8.75276 14.5859 9.08854 15.0001 9.08854C15.4143 9.08854 15.7501 8.75276 15.7501 8.33854H15.0001H14.2501ZM18.3334 5.00521V4.25521H15.0001V5.00521V5.75521H18.3334V5.00521ZM15.0001 5.00521V4.25521H11.6667V5.00521V5.75521H15.0001V5.00521ZM15.0001 1.67188H14.2501V5.00521H15.0001H15.7501V1.67188H15.0001ZM15.0001 5.00521H14.2501V8.33854H15.0001H15.7501V5.00521H15.0001Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.58341 2.5C5.85146 2.5 3.98549 2.5 2.82612 3.65937C1.66675 4.81874 1.66675 6.68471 1.66675 10.4167C1.66675 14.1486 1.66675 16.0146 2.82612 17.174C3.98549 18.3333 5.85146 18.3333 9.58341 18.3333C13.3154 18.3333 15.1813 18.3333 16.3407 17.174C17.5001 16.0146 17.5001 14.1486 17.5001 10.4167V10",
				stroke: "white",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.16675 17.5026C7.67507 13.5432 11.6177 8.29219 17.5001 12.2305",
				stroke: "white",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6671_128240",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgImageAdd01;
